import React from "react";
import Tooltip from "components/Tooltip";
import { cn } from "utils/helpers";
import { HStack } from "@chakra-ui/react";
import { FiDownload, FiTrash2, FiX } from "react-icons/fi";

interface FileActionsProps {
	fileName: string;
	filePath?: string;
	hasErrored?: boolean;
	isPreview?: boolean;
	isUploading?: boolean;
	onDelete: () => void;
	onRetry: () => void;
	onCancel?: () => void;
}

/**
 * Provides the different actions available for the files in a list
 */
export const FileActions: React.FC<FileActionsProps> = ({
	hasErrored = false,
	isPreview = false,
	isUploading = false,
	filePath,
	fileName,
	onDelete,
	onCancel,
}) => {
	// Uploading → Cancel
	if (isUploading) {
		return (
			<Tooltip label="Cancel upload">
				<button
					type="button"
					onClick={onCancel}
					className="rounded-full bg-gray-200 p-2 hover:bg-red-200"
				>
					<FiX size={16} />
				</button>
			</Tooltip>
		);
	}

	// Error state is handled by UploadProgress retry button + cancel here
	if (hasErrored) {
		return (
			<Tooltip label="Cancel upload">
				<button
					type="button"
					onClick={onCancel}
					className="rounded-full bg-gray-200 p-2 hover:bg-red-200"
				>
					<FiX size={16} />
				</button>
			</Tooltip>
		);
	}

	// Preview mode → Download only
	if (isPreview && filePath) {
		return (
			<Tooltip label="Download file">
				<a
					href={filePath}
					target="_blank"
					rel="noreferrer"
					download={fileName}
					className="inline-flex rounded-full bg-gray-200 p-2 no-underline hover:bg-utility-brand-200"
				>
					<FiDownload size={16} className="text-gray-600" />
				</a>
			</Tooltip>
		);
	}

	// Default → Download + Delete
	return (
		<HStack spacing={2}>
			{filePath && (
				<Tooltip label="Download file">
					<a
						href={filePath}
						target="_blank"
						rel="noreferrer"
						download={fileName}
						className="inline-flex rounded-full bg-gray-200 p-2 no-underline hover:bg-utility-brand-200"
					>
						<FiDownload size={16} className="text-gray-600" />
					</a>
				</Tooltip>
			)}
			{!isPreview && <Tooltip
				label={
					<>
						Remove file
						<br />
						(cannot be undone)
					</>
				}
			>
				<button
					type="button"
					onClick={onDelete}
					className={cn("rounded-full bg-gray-200 p-2 hover:bg-red-200")}
				>
					<FiTrash2 size={16} />
				</button>
			</Tooltip>}
		</HStack>
	);
};
